/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import SelectableRow from '../../../../client/js/components/selection/SelectableRow'
import { getAmountIncludingTax } from '../../lib/common/transaction.mjs'
import CustomerLink from '../customer/CustomerLink'
import Ref from '../Ref'
import Amount from './Amount'
import TransactionStatusBadge from './TransactionStatusBadge'
import { getInvoiceLink } from '../../lib/links/invoiceLinks'
import { Table } from '@mantine/core'
import AnchorLink from '../../../../client/js/components/AnchorLink'

export type TransactionListItemProps = {
  item: Transaction
  itemLink: string
}

function TransactionListItem (props: TransactionListItemProps) {
  const { item, itemLink } = props
  const intl = useIntl()
  const total = useMemo(() => getAmountIncludingTax(item), [item])
  return (
    <SelectableRow value={item.id}>
      <Table.Td>
        <TransactionStatusBadge transaction={item} />
      </Table.Td>
      <Table.Td>
        {item.dueAt ? intl.formatDate(item.dueAt) : null}
      </Table.Td>
      <Table.Td>
        <AnchorLink to={itemLink.replace(/{id}/g, String(item.id))}>
          {item.label}
        </AnchorLink>
      </Table.Td>
      <Table.Td ta="end">
        <Amount value={total} colored />
      </Table.Td>
      <Table.Td>
        {item.Customer
          ? <CustomerLink customer={item.Customer} />
          : null}
      </Table.Td>
      <Table.Td>
        {item.invoiceId
          ? <AnchorLink to={getInvoiceLink(item.invoiceId)}>
            <Ref value={item.Invoice?.reference || '???'} />
          </AnchorLink>
          : null}
      </Table.Td>
    </SelectableRow>
  )
}

export default TransactionListItem
